
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_8607_3182)"}},[_c('path',{attrs:{"d":"M21.498 19c-.578 0-1.11.198-1.535.529l-6.317-5.751c.224-.374.352-.811.352-1.278a2.504 2.504 0 00-1.53-2.304L13.508 5a2.504 2.504 0 002.44-2h3.1c.231 1.14 1.241 2 2.45 2 1.378 0 2.5-1.121 2.5-2.5S22.875 0 21.497 0c-1.209 0-2.219.86-2.45 2h-3.1a2.504 2.504 0 00-2.45-2 2.503 2.503 0 00-2.5 2.5c0 1.035.63 1.924 1.528 2.304L11.487 10a2.505 2.505 0 00-2.44 2h-4.1a2.504 2.504 0 00-2.45-2 2.503 2.503 0 00-2.5 2.5c0 1.379 1.121 2.5 2.5 2.5 1.206 0 2.216-.86 2.45-2h4.1c.232 1.14 1.242 2 2.45 2 .551 0 1.06-.179 1.474-.482l6.34 5.771A2.502 2.502 0 0021.497 24c1.38 0 2.5-1.121 2.5-2.5s-1.12-2.5-2.499-2.5zm0-18c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5-1.5-.673-1.5-1.5.673-1.5 1.5-1.5zm-9.5 1.5c0-.827.673-1.5 1.5-1.5s1.5.673 1.5 1.5-.673 1.5-1.5 1.5-1.5-.673-1.5-1.5zM2.498 14c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5zm7.5-1.5c0-.827.673-1.5 1.5-1.5s1.5.673 1.5 1.5-.673 1.5-1.5 1.5-1.5-.673-1.5-1.5zm11.5 10.5c-.827 0-1.5-.673-1.5-1.5 0-.307.093-.593.252-.83a.495.495 0 00.217-.257A1.496 1.496 0 0121.5 20c.827 0 1.5.673 1.5 1.5s-.674 1.5-1.5 1.5zm-16.5-2a1 1 0 11-2 0 1 1 0 012 0zm19-9a1 1 0 11-2 0 1 1 0 012 0zm-12 11a1 1 0 11-2 0 1 1 0 012 0zm-12-22a1 1 0 112 0 1 1 0 01-2 0zm4 4a1 1 0 112 0 1 1 0 01-2 0z","fill":"#000C1F"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_8607_3182"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    